import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import Button from "@components/buttons/Button";
import IconBase from "@components/text/IconBase";
import useMyClient from "@hooks/useMyClient";
import { journeyRoute } from "@utils/routeUtils";

type Props = ComponentProps<typeof Button> & {
  hideIcon?: boolean;
  journeyId: string;
  messageKey?: string;
};

const ScheduleConsultButton = ({ hideIcon = false, journeyId, messageKey, ...props }: Props) => {
  const myClient = useMyClient();

  return (
    <Button
      {...props}
      data-test="schedule-consult"
      routerLink={journeyRoute({ journeyId, linkAfterJourney: "/schedule-consult", myClient })}
    >
      <FormattedMessage id={messageKey ?? "pages.client.consults.scheduleConsult"} />
      {!hideIcon && <IconBase icon="calendarCheck" slot="end" />}
    </Button>
  );
};

export default ScheduleConsultButton;
